"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripArray = exports.stripEmptyValues = exports.replaceValues = exports.handleEvent = exports.isEmpty = exports.isObject = exports.isArray = exports.isDate = exports.isNullish = exports.identity = void 0;
function identity() {
}
exports.identity = identity;
function isNullish(value) {
    return value === undefined || value === null;
}
exports.isNullish = isNullish;
function isDate(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.getMonth) === 'function';
}
exports.isDate = isDate;
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
function isObject(value) {
    return !isDate(value) && !isArray(value) && typeof value === 'object' && value !== null;
}
exports.isObject = isObject;
function isEmpty(value) {
    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }
    return isNullish(value) || value === '';
}
exports.isEmpty = isEmpty;
function handleEvent(onChange, ...args) {
    return event => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        const value = (event && event.target) ? event.target.value : event;
        if (onChange) {
            onChange(value, ...args);
        }
    };
}
exports.handleEvent = handleEvent;
function replaceValues(object, value) {
    return Object.keys(object).reduce((a, b) => (Object.assign(Object.assign({}, a), { [b]: value })), {});
}
exports.replaceValues = replaceValues;
function stripEmptyValues(object) {
    const result = {};
    for (const [k, v] of Object.entries(object)) {
        if (!isEmpty(v)) {
            result[k] = v;
        }
    }
    return result;
}
exports.stripEmptyValues = stripEmptyValues;
function stripArray(array) {
    const stripped = array.filter(e => !isNullish(e));
    if (stripped.length === 0) {
        return null;
    }
    return stripped;
}
exports.stripArray = stripArray;
//# sourceMappingURL=utils.js.map